<template>
    <div class="modal fade panelbox panelbox-left" id="sidebarPanel" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-body p-0">
                  <!-- cuadro de perfil -->
                  <div class="profileBox pt-2 pb-2">
                      <div class="image-wrapper">
                          <img src="../assets/logo-b.png" alt="image" class="imaged  w36">
                      </div>
                      <div class="in">
                          <strong>{{ userData.username }}</strong>
                          <div class="text-muted">ASW-{{ userData.id }}</div>
                      </div>
                      <a href="#" class="btn btn-link btn-icon sidebar-close" data-bs-dismiss="modal">
                          <ion-icon name="close-outline"></ion-icon>
                      </a>
                  </div>
                  <!-- * cuadro de perfil -->
                  <!-- balance -->
                  <!-- <div class="sidebar-balance">
                      <div class="listview-title">Saldo</div>
                      <div class="in">
                          <h1 class="amount">$ {{ balance }}</h1>
                      </div>
                  </div> -->
                  <!-- * balance -->

                  <!-- grupo de acciones -->
                  <!-- <div class="action-group"> -->
                      <!-- <a href="index.php" class="action-button">
                          <div class="in">
                              <div class="iconbox">
                                  <ion-icon name="add-outline"></ion-icon>
                              </div>
                              Depósito
                          </div>
                      </a>
                      <a href="index.php" class="action-button">
                          <div class="in">
                              <div class="iconbox">
                                  <ion-icon name="arrow-down-outline"></ion-icon>
                              </div>
                              Retiro
                          </div>
                      </a>
                      <a href="index.php" class="action-button">
                          <div class="in">
                              <div class="iconbox">
                                  <ion-icon name="arrow-forward-outline"></ion-icon>
                              </div>
                              Enviar
                          </div>
                      </a> -->
                      <!-- <a href="app-cards.php" class="action-button">
                          <div class="in">
                              <div class="iconbox">
                                  <ion-icon name="card-outline"></ion-icon>
                              </div>
                              Mis Tarjetas
                          </div>
                      </a> -->
                  <!-- </div> -->
                  <!-- * grupo de acciones -->

                  <!-- menú -->
                  <div class="listview-title mt-1">Menú</div>
                  <ul class="listview flush transparent no-line image-listview">
                      <li>
                        <router-link :to="{ name: 'home' }" class="item">
                            <div class="icon-box bg-primary">
                                <ion-icon name="pie-chart-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Visión General
                                <!-- <span class="badge badge-primary">10</span> -->
                            </div>
                        </router-link>
                      </li>
                      <!-- <li>
                        <a href="/pages" class="item">
                            <div class="icon-box bg-primary"><ion-icon name="document-text-outline"></ion-icon></div>
                            <div class="in">Páginas</div>
                        </a>
                      </li> -->
                      <!-- <li>
                          <a href="app-components.php" class="item">
                              <div class="icon-box bg-primary">
                                  <ion-icon name="apps-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Componentes
                              </div>
                          </a>
                      </li> -->
                      <!-- <li>
                          <a href="app-cards.php" class="item">
                              <div class="icon-box bg-primary">
                                  <ion-icon name="card-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Mis Tarjetas
                              </div>
                          </a>
                      </li> -->
                  </ul>
                  <!-- * menú -->

                  <!-- otros -->
                  <div class="listview-title mt-1">Otros</div>
                  <ul class="listview flush transparent no-line image-listview">
                      <li>
                        <a href="/settings" class="item">
                            <div class="icon-box bg-primary"><ion-icon name="settings-outline"></ion-icon></div>
                            <div class="in">Configuración</div>
                        </a>
                      </li>
                      <!-- <li>
                        <a href="/settings/banks" class="item">
                            <div class="icon-box bg-primary"><ion-icon name="wallet-outline"></ion-icon></div>
                            <div class="in">Metodos de pago</div>
                        </a>
                      </li> -->
                      
                      <li>
                        <a href="https://ayuda.sombrerowallet.com" target="_blank" class="item">
                            <div class="icon-box bg-primary"><ion-icon name="chatbubble-outline"></ion-icon></div>
                            <div class="in">Soporte</div>
                        </a>
                      </li>
                      <li>
                          <a href="#" class="item" @click="logoutAPI">
                              <div class="icon-box bg-primary">
                                  <ion-icon name="log-out-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Cerrar sesión
                              </div>
                          </a>
                      </li>
                  </ul>
                  <!-- * otros -->

                  <!-- menú -->
                  <div class="listview-title mt-1">Verificaciones</div>
                  <ul class="listview flush transparent no-line image-listview">
                      <li>
                          <a href="#" class="item">
                              <div class="icon-box bg-primary">
                                <ion-icon name="mail-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Correo Electrónico
                                  <span class="badge badge-primary" v-if="userData.validation_email == true"><ion-icon name="checkmark-outline"></ion-icon></span>
                                  <span class="badge badge-danger" v-else><ion-icon name="close-outline"></ion-icon></span>
                              </div>
                          </a>
                      </li>
                      <li>
                          <a href="/validate-mobile" class="item">
                              <div class="icon-box bg-primary">
                                <ion-icon name="call-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Teléfono Móvil
                                  <span class="badge badge-primary" v-if="userData.validation_mobile == true"><ion-icon name="checkmark-outline"></ion-icon></span>
                                  <span class="badge badge-danger" v-else><ion-icon name="close-outline"></ion-icon></span>
                              </div>
                          </a>
                      </li>
                      <li>
                          <a href="/validate-fa2" class="item">
                              <div class="icon-box bg-primary">
                                <ion-icon name="call-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Doble Factor (FA2)
                                  <span class="badge badge-primary" v-if="userData.validation_fa2 == true"><ion-icon name="checkmark-outline"></ion-icon></span>
                                  <span class="badge badge-danger" v-else><ion-icon name="close-outline"></ion-icon></span>
                              </div>
                          </a>
                      </li>
                      <!-- <li>
                          <a href="#" class="item">
                              <div class="icon-box bg-primary">
                                <ion-icon name="id-card-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Identidad
                                  <span class="badge badge-primary" v-if="userData.validation_identy == true"><ion-icon name="checkmark-outline"></ion-icon></span>
                                  <span class="badge badge-danger" v-else><ion-icon name="close-outline"></ion-icon></span>
                              </div>
                          </a>
                      </li>
                      <li>
                          <a href="#" class="item">
                              <div class="icon-box bg-primary">
                                <ion-icon name="location-outline"></ion-icon>
                              </div>
                              <div class="in">
                                  Ubicacion
                                  <span class="badge badge-primary" v-if="userData.validation_address == true"><ion-icon name="checkmark-outline"></ion-icon></span>
                                  <span class="badge badge-danger" v-else><ion-icon name="close-outline"></ion-icon></span>
                              </div>
                          </a>
                      </li> -->
                  </ul>
                  <!-- * menú -->

                  <!-- enviar dinero -->
                  <!-- <div class="listview-title mt-1">Enviar Dinero</div>
                  <ul class="listview image-listview flush transparent no-line">
                      <li>
                          <a href="#" class="item">
                              <img src="assets/img/sample/avatar/avatar2.jpg" alt="image" class="image">
                              <div class="in">
                                  <div>Artem Sazonov</div>
                              </div>
                          </a>
                      </li>
                      <li>
                          <a href="#" class="item">
                              <img src="assets/img/sample/avatar/avatar4.jpg" alt="image" class="image">
                              <div class="in">
                                  <div>Sophie Asveld</div>
                              </div>
                          </a>
                      </li>
                      <li>
                          <a href="#" class="item">
                              <img src="assets/img/sample/avatar/avatar3.jpg" alt="image" class="image">
                              <div class="in">
                                  <div>Kobus van de Vegte</div>
                              </div>
                          </a>
                      </li>
                  </ul> -->
                  <!-- * enviar dinero -->
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            // balance: 0,
        }
    },
    computed: {
        ...mapState(['userData']),
        balance() {
            return this.$root.total.amount;
        }
    },
    methods: {
        ...mapActions(['logoutAPI']),
    }
}
</script>